import { computed as e, defineComponent as t, useSlots as n } from "vue";
//#region src/composables/useSlotsExists.ts
function r(r) {
	let i = n();
	function o(e, t) {
		return i[e]?.(t ?? {});
	}
	let s = t({
		props: { slotName: {
			type: String,
			required: !0
		} },
		setup(e) {
			return { slotName: e.slotName };
		},
		render(e) {
			return o(e.slotName, a(e.$attrs));
		}
	});
	return e(() => {
		let e = {};
		return r && r.forEach((t) => {
			e[t] = !!i[t]?.()?.length;
		}), {
			SlotRender: s,
			slots: i,
			getSlots: o,
			...e
		};
	});
}
function i(e) {
	return e.replace(/-([a-z0-9])/gi, (e, t) => t.toUpperCase());
}
function a(e) {
	return Object.assign({}, e, Object.fromEntries(Object.entries(e).map(([e, t]) => [i(e), t])));
}
//#endregion
export { r as useSlotsExists };

//# sourceMappingURL=useSlotsExists.js.map